// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Uyrg","content":"styles_content__3SnXT","checkbox":"styles_checkbox__2o3aI","checkboxLabel":"styles_checkboxLabel__3Sa-r"};